import { Autocomplete, TextField } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
	getGpsrProductTypeReferencesLoad,
	getGpsrProductTypeRegulationsGroupTypes,
	getGpsrRegulationsReferencesLoad,
} from 'redux/reducers/gpsr/selectors';
import { TGetRegulationsReferences } from 'redux/reducers/gpsr/types';

export type RegulationsReferencesAutocompleteProps = {
	valueIndex: number | null;
	setValueIndex: (index: number | null) => void;
	regulationsReferences: TGetRegulationsReferences[];
};

export const RegulationsReferencesAutocomplete: FC<RegulationsReferencesAutocompleteProps> = ({
	valueIndex,
	setValueIndex,
	regulationsReferences,
}) => {
	const regulationsReferencesLoading = useSelector(getGpsrRegulationsReferencesLoad);

	const options = regulationsReferences
		? regulationsReferences.map(reference => reference.regulName)
		: [];

	const value = valueIndex !== null ? (regulationsReferences[valueIndex]?.regulName ?? null) : null;

	const handleChange = (event: any, newValue: string | null) => {
		console.log('========newValue', newValue);
		console.log(
			'========setValueIndex',
			newValue ? regulationsReferences.findIndex(item => item.regulName === newValue) : null,
		);
		setValueIndex(
			newValue ? regulationsReferences.findIndex(item => item.regulName === newValue) : null,
		);
	};

	return (
		<Autocomplete
			options={options}
			value={value}
			onChange={handleChange}
			renderInput={params => <TextField {...params} label="Regulations" />}
			loading={regulationsReferencesLoading}
			loadingText="Loading regulations..."
			size="small"
		/>
	);
};
